module.exports = __webpack_public_path__ + "static/media/google_app_store.8e585868.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/google_app_store.png
// module id = 603
// module chunks = 0